import Loading from '@components/common/Loading';
import Notification from '@components/common/Notification';
import { API_URL } from '@redux/api';
import axios from 'axios';
import React, { useState } from 'react'
import { NotificationType } from 'react-app-env';

type Props = {
  itemId: string | undefined;
  itemName: string | undefined;
  onCloseModal: () => void;
};

const DeleteItem = ({
  itemId,
  itemName,
  onCloseModal
}: Props) => {

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [notification, setNotification] = useState<NotificationType | null>(null);

  const onDeleteItem = async() => {
    setIsLoading(true);
    setNotification(null);

    const response = await axios.delete(`${API_URL}/inventory/item/${itemId}`);
    const { status } = response;

    if(status === 200) {
      setIsLoading(false);
      setNotification({
        isError: false,
        title: "Sukses",
        text: "Data barang berhasil dihapus."
      });

      setTimeout(() => {
        setNotification(null);
        onCloseModal();
      }, 3000);
    } else {
      console.log(response)
      setIsLoading(false);
      setNotification({
        isError: true,
        title: "Error",
        text: "Terjadi kesalahan. Coba beberapa saat lagi."
      });
      
      setTimeout(() => {
        setNotification(null);
      }, 5000)
    };
  };

  return (
    <>
      <h2>Data barang akan terhapus secara permanen</h2>
      <p>Yakin ingin menghapus data barang <span className="capitalize font-semibold">{itemName}</span> ?</p>

      <div className='mt-5'>
        <Notification notification={notification} />
      </div>

      { isLoading ? 
        <div>
          <Loading loading={isLoading} type='beat-loader' size={10} parentClass='text-sm' />
        </div>
        : <div className="flex items-center justify-between mt-5">
          <button
            className="py-2 px-4 bg-red-600 text-white rounded-xl"
            onClick={onDeleteItem}
            disabled={isLoading || notification !== null}
          >
            Hapus
          </button>
          <button
            className="py-2 px-4 border border-red-600 text-red-600 rounded-xl"
            onClick={onCloseModal}
            disabled={isLoading || notification !== null}
          >
            Batal
          </button>
        </div>
      }
    </>
  );
};

export default DeleteItem;